import { ToolLine } from "../aui/ToolLine";
import { ApprovalCard } from "../choices/ApprovalCard";
import type { NativeCard, NativeCardProps } from ".";
import { FlowApprovalCard } from "./flow/FlowApprovalCard";
import { flowCard } from "./flow/payload";

/** The call's line, then its approval: the flow card when the choice carries one (F2). */
function MerchantFlow({ artifact }: NativeCardProps) {
  return (
    <div className="flex flex-col gap-2">
      <ToolLine line={artifact.line} state={artifact.state} />
      {artifact.choiceRef ? <ApprovalCard choiceRef={artifact.choiceRef} /> : null}
    </div>
  );
}

/**
 * `send_merchant_flow`: its approval as the native flow card. The same entry draws the approvals
 * no tool part holds (a follow-up, an app's approval), by the card's kind (`nativeChoiceCard`).
 */
export const MERCHANT_FLOW_CARD: NativeCard = {
  Card: MerchantFlow,
  shows: (artifact) => artifact.choiceKind === "approval" && artifact.choiceRef != null,
  choice: { Card: FlowApprovalCard, reads: (choice) => flowCard(choice) != null },
};
